import {COLON, MINUS, PLUS} from '../utils';

export function convertMinutesToUtcOffset(minutes: number) {
  const SIGN = minutes > 0 ? PLUS : MINUS; // @xxxsnake should be + or - when equal to 0
  const HOURS = `0${(Math.abs(minutes) / 60) ^ 0}`.slice(-2);
  const MINUTES = `0${Math.abs(minutes) % 60}`.slice(-2);

  return `${SIGN}${HOURS}${COLON}${MINUTES}`;
}
